@if (config.componentName === 'marketplace-search') {
  <sirius-search
    data-cy="marketplace-search"
    tabindex="-1"
    [busy]="fetching$"
    [value]="searchQuery"
    (submitEvent)="onSearch($event)"
    (clearEvent)="onSearch($event)"
    [rounded]="true">
  </sirius-search>
}
